export const projects = [
  {
    id: 3,
    title: "E-Tuition-BD",
    description:
      "A full-stack e-learning platform that allows students to access online courses, make secure payments, and track their learning progress through a modern dashboard.",

    role: "Frontend & API Integration",
    featured: true,

    image:
      "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=1200",

    demoUrl: "https://e-tuition-bd-3d12f.web.app/",
    githubUrl: "https://github.com/Rabeya-Khatun1/e-tuition-bd-client",

    technologies: [
      "React.js",
      "Node.js",
      "Express.js",
      "MongoDB",
      "Tailwind CSS",
      "Stripe API",
      "Firebase Auth"
    ],

    keyFeatures: [
      "User authentication with role-based access",
      "Admin dashboard for course and user management",
      "Secure online payment integration using Stripe",
      "Video-based learning with progress tracking",
      "Fully responsive UI"
    ],

    ui: {
      gradient: "from-blue-500 to-cyan-500",
      bgColor: "bg-blue-50",
      shadowColor: "shadow-blue-200"
    }
  },

  {
    id: 4,
    title: "MovieMaster Pro",
    description:
      "A full-stack movie management system allowing users to browse, filter, and manage movies with authentication and dynamic features.",

    role: "Frontend Development & Firebase Auth",
    featured: true,

    image:
      "https://images.pexels.com/photos/8261568/pexels-photo-8261568.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",

    demoUrl: "https://movie-master-auth.web.app/",
    githubUrl: "https://github.com/Rabeya-Khatun1/movie-master-pro-client",

    technologies: [
      "React.js",
      "Node.js",
      "Express.js",
      "MongoDB",
      "Firebase Auth"
    ],

    keyFeatures: [
      "CRUD operations for movies",
      "Advanced filtering and search",
      "Firebase authentication",
      "Movie rating system"
    ],

    ui: {
      gradient: "from-emerald-500 to-teal-500",
      bgColor: "bg-emerald-50",
      shadowColor: "shadow-emerald-200"
    }
  },


 {
    id: 1, 
    title: "LearnHub - LMS Platform",
    description:
      "A comprehensive learning management system featuring course enrollment, progress tracking, and interactive lessons for students and instructors.",

    role: "Full Stack Development",
    featured: true,

    image:
      "https://images.unsplash.com/photo-1501504905252-473c47e087f8?w=1200", 

    demoUrl: "https://learnhub-fawn.vercel.app/",
    githubUrl: "https://github.com/Rabeya-Khatun1/LearnHub",

    technologies: [
      "React JS",
      "Node JS",
      "Express JS",
      "MongoDB",
      "Firebase",
      "Tailwind CSS"
    ],

    keyFeatures: [
      "Course browsing and filtered search",
      "Secure student/instructor authentication",
      "Enrolled course dashboard and progress bar",
      "Admin panel for managing courses and users"
    ],

    ui: {
      gradient: "from-blue-600 to-indigo-600",
      bgColor: "bg-blue-50",
      shadowColor: "shadow-blue-200"
    }
  },
{
    id: 2,
    title: "Sondipon Shilpigosthi",
    description:
      "A cultural organization platform dedicated to promoting art, music, and local heritage with event management and artist showcase features.",

    role: "Frontend Development (Next.js)",
    featured: true,

    image:
      "https://i.ibb.co.com/B54W3vGV/Screenshot-2026-03-07-232534.png", 

    demoUrl: "https://sondipon.vercel.app/", 

    technologies: [
      "Next.js",
      "Tailwind CSS",
      "DaisyUI",
      "Framer Motion",
      "JavaScript"
    ],

    keyFeatures: [
      "Cultural event listing and details",
      "Artist profile and gallery showcase",
      "Interactive event registration system",
      "Responsive design for all devices"
    ],

    ui: {
      gradient: "from-amber-500 to-orange-600",
      bgColor: "bg-orange-50",
      shadowColor: "shadow-orange-200"
    }
  },



];
